<div class="close">
  <button (click)="close()">
    <img
      alt="close"
      width="20"
      height="20"
      src="../../../assets/images/close.svg"
    />
  </button>
</div>
<div class="content">
  <div class="title">系统公告</div>
  <div class="detail" [innerHTML]="data.content"></div>
  <div class="button">
    <button (click)="close()">确认</button>
  </div>
</div>
